// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2I8qz","loaderOuter":"PageOverlayLoader_loaderOuter__3OfRz"};